/**
 * Maximum activity type code length
 */
export const MAX_ACTIVITY_TYPE_CODE_LENGTH = 64

/**
 * Maximum activity type label length
 */
export const MAX_ACTIVITY_TYPE_LABEL_LENGTH = 255

/**
 * Maximum activity type description length
 */
export const MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH = 2000

/**
 * Error messages
 */
export const ACTIVITY_TYPE_ERRORS = {
  NOT_FOUND: 'Type d\'activité non trouvé',
  CODE_EXISTS: 'Ce code existe déjà',
  IN_USE: 'Ce type est utilisé par des activités et ne peut être supprimé',
  INVALID_JSON_SCHEMA: 'Le schéma JSON fourni est invalide',
  INVALID_CONFIG: 'La configuration par défaut est invalide',
  CREATION_FAILED: 'Erreur lors de la création du type d\'activité',
  UPDATE_FAILED: 'Erreur lors de la mise à jour du type d\'activité',
  DELETE_FAILED: 'Erreur lors de la suppression du type d\'activité',
} as const

/**
 * Success messages
 */
export const ACTIVITY_TYPE_SUCCESS = {
  CREATED: 'Type d\'activité créé avec succès',
  UPDATED: 'Type d\'activité mis à jour avec succès',
  DELETED: 'Type d\'activité supprimé avec succès',
} as const
